import { Heading, Layout } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { DealerCard } from "./DealerCard";
import { useMatchMakerWizard } from "../../hooks/useMatchMakerWizard";

export const CurrentlySelected = () => {
    const { t } = useTranslation(["dealerselection"]);
    const { defaultDealer } = useMatchMakerWizard();
    const brand = process.env.REACT_APP_WEBSITE_BRAND;

    return (
        <Layout.Item default="1/4" m="1/3" s="1/1">
            <Heading level={3} className="u-font-size-fs2">{brand === "audi" ? t("dealerselection:currently-dealer-section.titleAudi"): t("dealerselection:currently-dealer-section.title")}</Heading>
            {defaultDealer && <DealerCard dealer={defaultDealer} />}
        </Layout.Item>
    );
};
